import { useState } from 'react';
import { Button, Card, CardContent, CardHeader, Collapse, Grid, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { BuildingFloorForm } from './building-floor.form';
import { BuildingOtherForm } from './building-other.form';
import { CreateBuildingFloorButton } from './create-building-floor.button';
import { CreateBuildingOtherDataButton } from './create-building-other-data.button';
import { DeleteButton } from '../../../components/delete-button.component';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { UserPermissionName } from '../../../models/user-permission-name';
import { GuardedComponent } from '../../../components/guarded-component';

interface BuildingFormProps {
  name: string;
  index: number;
  onRemove: (index: number) => void;
  page?: string;
  syncWithDux: any
}

export const BuildingForm = ({ name, index, onRemove, page, syncWithDux }: BuildingFormProps) => {
  const [expanded, setExpanded] = useState(true);
  const { control, getValues, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${name}.buildingFloors`,
    keyName: 'fID',
  });

  const {
    fields: fieldsOther,
    append: appendOther,
    remove: removeOther,
  } = useFieldArray({
    control,
    name: `${name}.buildingCommonAreas`,
    keyName: 'oID',
  });

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleAddFloor = (buildings: any) => {
    const floor = buildings?.projectBuildings?.[0]?.buildingFloors?.[0];
    if (floor) {
      append(floor);
      const floors = getValues(`${name}.buildingFloors`);
      setValue(`${name}.floorsCount`, floors.length);
    }
  };

  const handleRemoveFloor = (index: number) => {
    remove(index);
    const floors = getValues(`${name}.buildingFloors`);
    setValue(`${name}.floorsCount`, floors.length);
  };

  const handleAddOtherData = (data: any) => {
    appendOther(data);
  };

  const handleRemoveOtherData = (index: number) => {
    removeOther(index);
  };

  return (
    <Card elevation={0} className="buildingBlocks">
      <CardHeader
        className="subHead noPad"
        title={
          <Grid item lg={12} sm={12} xl={12} xs={12} className="generateFloorContainer">
            {/* <div className="countRound">{index + 1}</div> */}
            <div style={{ minWidth: '350px' }}>
              <FormInput name={`${name}.buildingName`} label="Building Name" />
            </div>
            <div>
              <FormInput name={`${name}.floorsCount`} label="No. of Floors" disabled />
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <GuardedComponent requiredPermissions={[UserPermissionName.DELETE_UNIT]}>
                <DeleteButton
                  data={undefined}
                  deleteMutationConfig={() => projectsApiKeyStore.deleteBuilding(getValues(`${name}.buildingID`))}
                  onDeleted={() => onRemove(index)}
                >
                  <span className="btn btn-danger btn-outlined">DELETE BUILDING</span>
                </DeleteButton>
              </GuardedComponent>
            </div>
          </Grid>
        }
        action={
          <IconButton onClick={handleExpandClick}>{expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</IconButton>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className="FUBlocksWrap ">
          <Grid container>
            <Grid item lg={12} sm={12} xl={12} xs={12} className="noPad">
              {fields.map((field, i) => (
                <BuildingFloorForm
                  key={field.fID}
                  name={`${name}.buildingFloors.${i}`}
                  index={i}
                  onRemove={handleRemoveFloor}
                  building={getValues(name)}
                  page={page}
                  syncWithDux={syncWithDux}
                />
              ))}
              <div className="d-flex">
                <CreateBuildingFloorButton
                  onBuildingFloorCreated={handleAddFloor}
                  projectID={getValues('projectID')}
                  building={getValues(name)}
                />
              </div>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12} className="noPad">
              {fieldsOther.map((field, index) => (
                <BuildingOtherForm
                  key={field.oID}
                  name={`${name}.buildingCommonAreas.${index}`}
                  index={index}
                  onRemove={handleRemoveOtherData}
                  totalItemCount={fieldsOther.length}
                  projectID={getValues('projectID')}
                  page={page}
                  
                  syncWithDux={syncWithDux}
                />
              ))}
              <CreateBuildingOtherDataButton
                onBuildingOtherDataCreated={handleAddOtherData}
                projectID={getValues('projectID')}
                building={getValues(name)}
                syncWithDux={syncWithDux}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};
